// extracted by mini-css-extract-plugin
module.exports = {"modal":"ManageExpenditureModal_modal__27HUF","content":"ManageExpenditureModal_content__YnuJ-"};